import APIURL from "../axios";
import { useQuery } from "react-query";

const Entertainment = async (uuid, lang) => {
  return await APIURL.get(`/${uuid}/tour-desks`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      lang: lang,
    },
  });
};
export const ShowEntertainment = (uuid, lang) => {
  return useQuery(`tour-desks-${lang}`, () =>
    Entertainment(uuid, lang)
  );
};

const Entertainments = async (uuid, e_uuid, lang) => {
  // return await APIURL.get(`/${uuid}/entertainment/categories/${e_uuid}`, {
  return await APIURL.get(`/${uuid}/tour-desk/${e_uuid}/categories`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      lang: lang,
    },
  });
};
export const ShowEntertainments = (uuid, e_uuid, lang) => {
  return useQuery(`tour-desk-categories-${lang}-${e_uuid}`, () =>
    Entertainments(uuid, e_uuid, lang)
  );
};
const PharmacySubMenu = async (uuid, ph_uuid, id, lang) => {
  return await APIURL.get(`/${uuid}/pharmacy/${ph_uuid}?cat=${id}`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      lang: lang,
    },
  });
};

export const ShowPharmacySubMenu = (uuid, ph_uuid, id, lang) => {
  return useQuery(`pharmacy_sub_menu-${lang}-${id}`, () =>
    PharmacySubMenu(uuid, ph_uuid, id, lang)
  );
};
